export default __webpack_public_path__ + "60589f361173df7b158c4ea002492a67.svg";